import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import BrandAiChat from "./components/feature/BrandAiChat";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SiteLocaleTranslator from "./components/feature/SiteLocaleTranslator";
import ScrollToTop from "@/components/feature/ScrollToTop";
import CanonicalUpdater from "@/components/feature/CanonicalUpdater";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteLocaleTranslator />
        <ScrollToTop />
        <CanonicalUpdater />
        <AppRoutes />
        <BrandAiChat brandName="千華駐科技出版" siteUrl="https://chianva.sonbook.net" />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
